// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phase-created{
    cursor: pointer;
    position: relative;
}

.phase-created-disabled {
    pointer-events: none;
    opacity: 0.4;
}

.phase-created__field {
    padding: var( --space-half ) 0 var( --space-half ) var( --space-half );
    border: 1px solid var( --new-gray-background-color );
    box-sizing: border-box;
    border-radius: var( --space-quarter );
    background-color: var(--white-color);
    height: 70px;
    margin-right: var( --space );
    min-width: 220px;
}

.phase-created__field.selected-phase{
    background-color: var( --new-gray-background-color );    
    border-radius: var( --space-quarter );
}

.phase-created__field__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.phase-created.selected-phase__validation {
    min-width: 284px;
    /* display: flex;
    align-items: center; */
}

.phase-created.selected-phase__validation .phase-created__field.selected-phase{
    margin-right: var( --space );
}

.phase-created__field__content__text.baloa-table {
    color: var( --basic-gray-color );
}

.phase-created__field__content__text.baloa-names {
    color: var( --primary-dark-color );
    margin-right: var( --space );
}

.phase-created__field__content__options{
    font-size: var(--space-and-half);
}

.phase-created__option {
    box-shadow: 2px 2px 5px 2px #4444;
    list-style: none;
    z-index: 1;
    background: var( --white-color);
}

.phase-created__option_one_option{
    box-shadow: 2px 2px 5px 2px #4444;
    padding: var(--space-half);
    width: 100%;
    /* margin-top: calc(var( --space-x3)*2.3); */
    list-style: none;
    position: absolute;
    z-index: 1;
    /* margin-left: 1%; */
    background: var( --white-color);
}

.phase-created__option__list button {
    color: var( --primary-dark-color );    
}

.phase-created__option_two_option{
    box-shadow: 2px 2px 5px 2px #4444;
    padding: var(--space-half);
    width: 100%;
    /* margin-top: calc(var( --space-x3)*3); */
    list-style: none;
    position: absolute;
    z-index: 1;
    /* margin-left: 1%; */
    background: var( --white-color);
}

.phase-created__option_three_option{
    box-shadow: 2px 2px 5px 2px #4444;
    padding: var(--space-half);
    width: 100%;
    margin-top: calc(var( --space-x3)*3.8);
    list-style: none;
    position: absolute;
    z-index: 1;
    margin-left: 1%;
    background: var( --white-color);
}

/* .phase-created__option.options{
    margin-top: calc(var( --space-x3)*2);
} */

.phase-created__option__list{
    display: flex;
    justify-content: center;
}

.phases-created__phases__tooltip-msg {

    position: absolute;
    box-shadow: var(--shadow-card-2);
    width: 175px;
    border-radius: var(--space-half);
    background-color: var(--primary-dark-color);
    cursor: initial;
    left: 100%;
    z-index: 1;
    top: calc( var( --space-half-quarter ) * -1 );
}

.phases-created__phases__tooltip-msg p {
    padding: var(--space-half-quarter) var(--space-and-half) var(--space-half-quarter) var(--space-half-quarter);
    color: var(--white-color) !important;    
}

.phases-created__phases__tooltip-msg:after, .phases-created__phases__tooltip-msg:before {
	right: 100%;
	top: 40%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.phases-created__phases__tooltip-msg:after {
	
	border-right-color: var(--primary-dark-color);
	border-width: 10px;
	margin-top: -10px;
       
}
.phases-created__phases__tooltip-msg:before {
	border-color: rgba(194, 225, 245, 0);
	border-right-color: var(--primary-dark-color);
	border-width: 5px;
	margin-top: -5px;                           
}

.phases-created__phases__tooltip-msg__close-btn {
    color: white;
    position: absolute;
    right: 8px;
    background: var(--primary-very-dark-color);
    top: 8px;
    border-radius: 50%;
}

.phases-created__phases__tooltip-msg__close-btn {
    padding: 3px;
    cursor: pointer;
}

.phase-created__field__content_photo{
    width: 40px;
    margin-right: var(--space);
}

.phase-created__field {
    display: flex;
    align-items: center;
}

.tournament-phases__phase-options__container {
    position: relative;
}

.tournament-phases__phase-options__container:hover {
    cursor: pointer;
    
}

.tournament-phases-information_options-box.active {
    display: flex;
    flex-direction: column;
}

.tournament-phases-information_options-box {
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150 150 150 / 25%);
    width: 200px;
    display: none;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 8px;
    top: var(--space-x2);
}

.tournament-phases_create_phase_options-box__option{
    border-radius: 8px;
    padding: 8px;
    display: flex;
    gap: var(--space-half);
}

.tournament-phases_create_phase_options-box__option:hover{
    background-color: var(--new-background-color);
}

.phase-created__field_summary{
    width: 100%;
}

.tournament-phases__phase-options__container .icon-options{
    margin-right: var(--space);
}

.tournament-phases_create_phase_options-box__option .hubicon-edit::before{
    color: var(--primary-very-dark-color);
    font-size: 20px;
}

.tournament-phases_create_phase_options-box__option .hubicon-delete_question::before{
    color: var(--primary-very-dark-color);
    font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phase-created/TournamentPhaseCreatedComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,sEAAsE;IACtE,oDAAoD;IACpD,sBAAsB;IACtB,qCAAqC;IACrC,oCAAoC;IACpC,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB;0BACsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,UAAU;IACV,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,WAAW;IACX,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,WAAW;IACX,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,+BAA+B;AACnC;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,gCAAgC;IAChC,2CAA2C;IAC3C,eAAe;IACf,UAAU;IACV,UAAU;IACV,6CAA6C;AACjD;;AAEA;IACI,4GAA4G;IAC5G,oCAAoC;AACxC;;AAEA;CACC,WAAW;CACX,QAAQ;CACR,yBAAyB;CACzB,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;;CAEC,6CAA6C;CAC7C,kBAAkB;CAClB,iBAAiB;;AAElB;AACA;CACC,oCAAoC;CACpC,6CAA6C;CAC7C,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,0CAA0C;IAC1C,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,+CAA+C;IAC/C,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,eAAe;AACnB","sourcesContent":[".phase-created{\n    cursor: pointer;\n    position: relative;\n}\n\n.phase-created-disabled {\n    pointer-events: none;\n    opacity: 0.4;\n}\n\n.phase-created__field {\n    padding: var( --space-half ) 0 var( --space-half ) var( --space-half );\n    border: 1px solid var( --new-gray-background-color );\n    box-sizing: border-box;\n    border-radius: var( --space-quarter );\n    background-color: var(--white-color);\n    height: 70px;\n    margin-right: var( --space );\n    min-width: 220px;\n}\n\n.phase-created__field.selected-phase{\n    background-color: var( --new-gray-background-color );    \n    border-radius: var( --space-quarter );\n}\n\n.phase-created__field__content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.phase-created.selected-phase__validation {\n    min-width: 284px;\n    /* display: flex;\n    align-items: center; */\n}\n\n.phase-created.selected-phase__validation .phase-created__field.selected-phase{\n    margin-right: var( --space );\n}\n\n.phase-created__field__content__text.baloa-table {\n    color: var( --basic-gray-color );\n}\n\n.phase-created__field__content__text.baloa-names {\n    color: var( --primary-dark-color );\n    margin-right: var( --space );\n}\n\n.phase-created__field__content__options{\n    font-size: var(--space-and-half);\n}\n\n.phase-created__option {\n    box-shadow: 2px 2px 5px 2px #4444;\n    list-style: none;\n    z-index: 1;\n    background: var( --white-color);\n}\n\n.phase-created__option_one_option{\n    box-shadow: 2px 2px 5px 2px #4444;\n    padding: var(--space-half);\n    width: 100%;\n    /* margin-top: calc(var( --space-x3)*2.3); */\n    list-style: none;\n    position: absolute;\n    z-index: 1;\n    /* margin-left: 1%; */\n    background: var( --white-color);\n}\n\n.phase-created__option__list button {\n    color: var( --primary-dark-color );    \n}\n\n.phase-created__option_two_option{\n    box-shadow: 2px 2px 5px 2px #4444;\n    padding: var(--space-half);\n    width: 100%;\n    /* margin-top: calc(var( --space-x3)*3); */\n    list-style: none;\n    position: absolute;\n    z-index: 1;\n    /* margin-left: 1%; */\n    background: var( --white-color);\n}\n\n.phase-created__option_three_option{\n    box-shadow: 2px 2px 5px 2px #4444;\n    padding: var(--space-half);\n    width: 100%;\n    margin-top: calc(var( --space-x3)*3.8);\n    list-style: none;\n    position: absolute;\n    z-index: 1;\n    margin-left: 1%;\n    background: var( --white-color);\n}\n\n/* .phase-created__option.options{\n    margin-top: calc(var( --space-x3)*2);\n} */\n\n.phase-created__option__list{\n    display: flex;\n    justify-content: center;\n}\n\n.phases-created__phases__tooltip-msg {\n\n    position: absolute;\n    box-shadow: var(--shadow-card-2);\n    width: 175px;\n    border-radius: var(--space-half);\n    background-color: var(--primary-dark-color);\n    cursor: initial;\n    left: 100%;\n    z-index: 1;\n    top: calc( var( --space-half-quarter ) * -1 );\n}\n\n.phases-created__phases__tooltip-msg p {\n    padding: var(--space-half-quarter) var(--space-and-half) var(--space-half-quarter) var(--space-half-quarter);\n    color: var(--white-color) !important;    \n}\n\n.phases-created__phases__tooltip-msg:after, .phases-created__phases__tooltip-msg:before {\n\tright: 100%;\n\ttop: 40%;\n\tborder: solid transparent;\n\tcontent: \" \";\n\theight: 0;\n\twidth: 0;\n\tposition: absolute;\n\tpointer-events: none;\n}\n\n.phases-created__phases__tooltip-msg:after {\n\t\n\tborder-right-color: var(--primary-dark-color);\n\tborder-width: 10px;\n\tmargin-top: -10px;\n       \n}\n.phases-created__phases__tooltip-msg:before {\n\tborder-color: rgba(194, 225, 245, 0);\n\tborder-right-color: var(--primary-dark-color);\n\tborder-width: 5px;\n\tmargin-top: -5px;                           \n}\n\n.phases-created__phases__tooltip-msg__close-btn {\n    color: white;\n    position: absolute;\n    right: 8px;\n    background: var(--primary-very-dark-color);\n    top: 8px;\n    border-radius: 50%;\n}\n\n.phases-created__phases__tooltip-msg__close-btn {\n    padding: 3px;\n    cursor: pointer;\n}\n\n.phase-created__field__content_photo{\n    width: 40px;\n    margin-right: var(--space);\n}\n\n.phase-created__field {\n    display: flex;\n    align-items: center;\n}\n\n.tournament-phases__phase-options__container {\n    position: relative;\n}\n\n.tournament-phases__phase-options__container:hover {\n    cursor: pointer;\n    \n}\n\n.tournament-phases-information_options-box.active {\n    display: flex;\n    flex-direction: column;\n}\n\n.tournament-phases-information_options-box {\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150 150 150 / 25%);\n    width: 200px;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 8px;\n    top: var(--space-x2);\n}\n\n.tournament-phases_create_phase_options-box__option{\n    border-radius: 8px;\n    padding: 8px;\n    display: flex;\n    gap: var(--space-half);\n}\n\n.tournament-phases_create_phase_options-box__option:hover{\n    background-color: var(--new-background-color);\n}\n\n.phase-created__field_summary{\n    width: 100%;\n}\n\n.tournament-phases__phase-options__container .icon-options{\n    margin-right: var(--space);\n}\n\n.tournament-phases_create_phase_options-box__option .hubicon-edit::before{\n    color: var(--primary-very-dark-color);\n    font-size: 20px;\n}\n\n.tournament-phases_create_phase_options-box__option .hubicon-delete_question::before{\n    color: var(--primary-very-dark-color);\n    font-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
